import {
  BatteryLifeIcon,
  CircleIcon,
  CircularOutlineCheckIcon,
  GridItem,
  HeartbeatIcon,
  LayoutGrid,
  MobileConnectivityIcon,
  TypographyV3,
  WeightIcon,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import PDPTechSpecsFeatures from './PDPTechSpecsFeatures';
import PDPWhatsIncluded from './PDPWhatsIncluded';

const PDPTechSpecsSection = () => {
  const t = useTranslations();

  return (
    <LayoutGrid
      className="gap-y-10 bg-gray-450 pt-20 text-sandstone-200 lg:pt-0"
      data-cy="pdp-tech-specs"
      Element="section"
    >
      <GridItem
        className="lg:mr-4 lg:pb-20"
        colEnd={{ sm: 'main', md: 'main', lg: 10 }}
        colStart={{ sm: 'main' }}
        rowEnd={{ sm: 3 }}
        rowStart={{ sm: 1 }}
      >
        <PDPWhatsIncluded />
      </GridItem>
      <GridItem
        className="lg:pt-20"
        colEnd={{ sm: 'main' }}
        colStart={{ sm: 'main', md: 'main', lg: 10 }}
      >
        <TypographyV3 color="light" Element="h4" variant="h4">
          {t('ring_pdp_2025_tech_specs_title')}
        </TypographyV3>
      </GridItem>
      <GridItem
        className="pb-20"
        colEnd={{ sm: 'main' }}
        colStart={{ sm: 'main', md: 'main', lg: 10 }}
      >
        <PDPTechSpecsFeatures
          features={[
            {
              copy: 'ring_pdp_2025_tech_specs_sensors_list',
              Icon: HeartbeatIcon,
              id: 'materials',
              title: 'ring_pdp_2025_tech_specs_sensors_title',
            },
            {
              copy: 'ring_pdp_2025_tech_specs_compatibility_list',
              Icon: CircularOutlineCheckIcon,
              id: 'sensors',
              title: 'ring_pdp_2025_tech_specs_compatibility_title',
            },
            {
              copy: 'ring_pdp_2025_tech_specs_dimensions_list',
              Icon: WeightIcon,
              id: 'battery',
              title: 'ring_pdp_2025_tech_specs_dimensions_title',
            },
            {
              copy: 'ring_pdp_2025_tech_specs_battery_list',
              Icon: BatteryLifeIcon,
              id: 'dimensions',
              title: 'ring_pdp_2025_tech_specs_battery_title',
            },
            {
              copy: 'ring_pdp_2025_tech_specs_materials_list',
              Icon: CircleIcon,
              id: 'compatibility',
              title: 'ring_pdp_2025_tech_specs_materials_title',
            },
            {
              copy: 'ring_pdp_2025_tech_specs_connectivity_list',
              Icon: MobileConnectivityIcon,
              id: 'connectivity',
              title: 'ring_pdp_2025_tech_specs_connectivity_title',
            },
          ]}
        />
      </GridItem>
    </LayoutGrid>
  );
};

export default PDPTechSpecsSection;
